import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { HOME } from '../config/routes';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1rem;
  height: 100vh;

  p {
    margin-bottom: 3rem;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
`;

function NotFoundPage() {
  return (
    <Wrapper>
      <Title>404</Title>
      <p>Sorry - the page you are looking for can&apos;t be found!</p>
      <Link to={HOME}>
        <Button label="Go to homepage" />
      </Link>
    </Wrapper>
  );
}

export default NotFoundPage;
